import React from 'react';
import { FirstStep } from './first';
import { SecondStep } from './second';
import { ThirdStep } from './third';
import { FourthStep } from './fourth';
import { FifthStep } from './fifth';
import { SixthStep } from './sixth';
import { SeventhStep } from './seventh';
import { EighthStep } from './eighth';
import { NinethStep } from './nineth';
import { TenthStep } from './tenth';
import { EleventhStep } from './eleventh';

export type TStep = {
  id: string;
  name: string;
  description: string;
  component: React.ReactNode;
  notShow?: boolean;
};

export const steps: TStep[] = [
  {
    id: '1',
    name: 'Sign In',
    description: 'Step description',
    component: <FirstStep />,
  },
  {
    id: '2',
    name: 'Scholarship Selection',
    description: 'Step description',
    component: <SecondStep />,
  },
  {
    id: '3',
    name: 'Contact Information',
    description: 'Step description',
    component: <ThirdStep />,
  },
  {
    id: '4',
    name: 'Education',
    description: 'Step description',
    component: <FourthStep />,
  },
  {
    id: '5',
    name: 'Details of Programme',
    description: 'Step description',
    component: <FifthStep />,
  },
  {
    id: '6',
    name: 'Essay',
    description: 'Step description',
    component: <SixthStep />,
  },
  {
    id: '7',
    name: 'Leadership and Volunteerism',
    description: 'Leadership and Volunteerism',
    component: <SeventhStep />,
  },
  {
    id: '8',
    name: 'References',
    description: 'Step description',
    component: <EighthStep />,
  },
  {
    id: '9',
    name: 'Statistical Information',
    description: 'Step description',
    component: <NinethStep />,
  },
  {
    id: '10',
    name: "Applicant's E-signature",
    description: 'Step description',
    component: <TenthStep />,
  },
  {
    id: '11',
    name: 'Finished',
    description: 'Form submitted',
    component: <EleventhStep />,
    notShow: true,
  },
];
